import { IconFormNames, LifeArea, LocalizedLifeArea } from '@griply/types';

import { type DocumentSnapshot } from '../types/firestore';
import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const lifeAreaConverter = {
  fromFirestore: (snapshot: DocumentSnapshot): LifeArea | LocalizedLifeArea => {
    const data = firebaseObjectTimestampToDate(snapshot.data()) as Record<
      string,
      unknown
    >;
    return {
      ...data,
      iconName: Object.values(IconFormNames).includes(
        data.iconName as IconFormNames,
      )
        ? data.iconName
        : IconFormNames.PlaceholderIcon,
      visionPreview: data.visionPreview ?? null,
    } as LifeArea | LocalizedLifeArea;
  },
  toFirestore: (
    lifeArea: LifeArea | LocalizedLifeArea,
  ): Record<string, unknown> => lifeArea as unknown as Record<string, unknown>,
};
